
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";

export const VijaygarhFort=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Vijaygarh Fort </h1>
           <p className="sub-heading">Built at time of Mahabharata and also famous for Chandrakanta</p>
         </div>
         <div className="description">
         Vijaygarh Fort was built by the famous king Banasur, in the time of Mahabharat and was renovated by Maharaja Vijay Pal in 1040. Vijay Pal was a great Jadon Rajput King. Last ruler of Vijargarh Fort was Raja Chait Singh of Benares. He ruled until British reached this point. The fort is considered to be mesmeric and another fort is said to be hidden under it. This is the fort of Princess Chandrakanta. Near the main gateway of the fort there is a tomb, which is said to be that of Saiyyed Jain-ul-Abdin Meer Sahib popularly known as Hazrat Meeran Shah Baba. There are two tanks known as Mira Sagar and Ram Sagar near the tomb which are never dry.
         Vijaygarh Fort was built in the fifth century. it was built by the kings of coal of the Sonbhadra district, Uttar Pradesh India. The Vijaygarh fort is located 30 km from Robertsganj in Mau kalan village. This is the fort of Princess Chandrakanta. The unique feature of this fort is cave drawings, sculptures, inscriptions on rocks Made in Fort. The Fort is famous for perennial ponds inside the premises of the fort.
         Vijaygarh fort has both historical and archaeological importance. This elegant fort has also been pertinently described in the novel Chandrakanta by Babu Devkinandan Khatri along With Princess Chandrakanta . The Kanvarias in Shravan month collect water from Ram Sagar and then start their holy journey to the Shivdwar.Vijaygarh Fort was built by the famous king Banasur, in the time of Mahabharat and was renovated by Maharaja Vijay Pal in 1040 AD. Vijay Pal was a great Jadon Rajput King. Last ruler of Vijargarh Fort was Kashi Naresh Chet Singh. He ruled until British reached this point. The Fort is considered to be mesmeric and another fort is said to be hidden under this Fort. This is the fort of Princess Chandrakanta, Last king of this fort was Kashi Naresh Tej Singh. Near the main gateway of the fort there is a tomb, which is said to be that of Saiyyed Jain-ul-Abdin Meer Sahib popularly known as Hazrat Meeran Shah Baba. There are two tanks known as Mira Sagar and Ram Sagar near the tomb which are never being dry Vijaygarh fort contains several old temples & red stones pillars bearing an inscription of Vishnuverdhan feudatory of Samudragupta. The Fort is famous for its rock inscriptions, cave paintings, many statues and its perennial ponds. There are four ponds inside the premises of the fort which never get dried up. More than half the area of Vijargarh is covered by the steep and rugged hills of Kaimur Range. Between the two tanks there was a palace known as Rang Mahal which had artistic rock carvings and assumed as palace of Princess Chandrakanta. beside the tomb there is a tank known as Mira Sagar and beyond this another one known as Ram Sagar. </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort1.jpeg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort3.jpg')}
               alt="Mukha Fall 3"
               className="gallery-image"
             />
             {/* <p className="image-caption">The lush green surroundings of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort4.jpg')}
               alt="Mukha Fall 4"
               className="gallery-image"
             />
             {/* <p className="image-caption">The tranquil ambiance at sunset.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort5.jpg')}
               alt="Mukha Fall 5"
               className="gallery-image"
             />
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort6.jpg')}
               alt="Mukha Fall 5"
               className="gallery-image"
             />
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/Vijaygarh Fort/fort7.jpg')}
               alt="Mukha Fall 5"
               className="gallery-image"
             />
             {/* <p className="image-caption">A panoramic view of Mukha Fall's beauty.</p> */}
           </div>
         </div>
   
         <BookSection />
       </div>
     );
};